module.exports = __webpack_public_path__ + "img/140.1f45147f.jpg";